import { localize } from "@/base/locale/lang";

declare const GLOBAL_CONFIG: { EDITIONS: Record<string, IEditionInfo> } | undefined;

const configuredEditions = typeof GLOBAL_CONFIG !== 'undefined' ? GLOBAL_CONFIG.EDITIONS : undefined;

export interface IEditionInfo {
    key: string;
    title: string;
    locales?: {
        name: string;
        label: string
    }[];
}

export const Editions: Record<string, IEditionInfo> = {
    common: {
        key: 'common',
        title: '内网标准版',
    },
    timi: {
        key: 'timi',
        title: '天美专版',
    },
    public: {
        key: 'public',
        title: '公网标准版',
    },
    coo: {
        key: 'coo',
        title: '项目外包版',
    },
    hok: {
        key: 'hok',
        title: 'HOK',
        locales: [
            {
                name: 'zh',
                label: '中文',
            },
            {
                name: 'en',
                label: 'English',
            },
        ],
    },
    row: {
        key: 'row',
        title: localize('eiditionTitle.row'),
        locales: [
            {
                name: 'zh',
                label: '中文',
            },
            {
                name: 'en',
                label: 'English',
            },
        ],
    },
    resident: {
        key: 'resident',
        title: '其他版本',
    },
    ...configuredEditions,
}

export const CommonEdition = {
    key: 'common',
    title: '内网标准版',
}
